import { useCallback, useState } from "react";
import type { CreateServiceRequest } from "@/types/api";
import { OpenAiFields } from "./OpenAiFields";
import { parseOptionalInt } from "./parseOptionalInt";

export function useOpenAiFields() {
  const [apiKey, setApiKey] = useState("");
  const [model, setModel] = useState("");
  const [maxTokens, setMaxTokens] = useState("");

  const toPayload = useCallback((): Partial<CreateServiceRequest> => {
    const payload: Partial<CreateServiceRequest> = { api_key: apiKey };
    if (model) payload.model = model;
    payload.max_tokens = parseOptionalInt(maxTokens);
    return payload;
  }, [apiKey, model, maxTokens]);

  const fields = (
    <OpenAiFields
      apiKey={apiKey}
      setApiKey={setApiKey}
      model={model}
      setModel={setModel}
      maxTokens={maxTokens}
      setMaxTokens={setMaxTokens}
    />
  );

  return { fields, toPayload };
}
